<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <el-tabs>
        <el-tab-pane label="关系图">
          <el-button @click="setUserType(1)">业主</el-button>
          <el-button @click="setUserType(2)">公区</el-button>
          <MeterViewDiagram v-if="excel_list2.length>0" :excel_list="excel_list2" />
        </el-tab-pane>
        <el-tab-pane label="上传资料">

        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import MeterViewDiagram from "./MeterViewDiagram";
import ImportMeter from "./components/ImportMeter";
import ErpTreeStatus from "../Common/erp-tree-status";
export default {
  name: "MeterDiagram",
  components: {ErpTreeStatus, ImportMeter, MeterViewDiagram},
  data(){
    return{
      excel_list2:[],
      loading:false,
      project_id:'',
      user_type:2,
      house_name:""
    }
  },
  activated() {
    this.setUserType()
  },
  methods:{
    getList(){
      const that=this;
      that.excel_list2=[];
      that.project_id&&ERP.getRequest({
        url:"admin/Meter/getListAll",
        data:{
          project_id:that.project_id,
          user_type:that.user_type,
        },
      },ret=>{
        if(ret.code){
          that.excel_list2=ret.data;
        }
      })
    },
    setUserType(user_type=2){
      this.user_type=user_type;
      this.getList()
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.project_id = data.tree[0].pindex_id;
      this.house_name=tree_str;
      this.getList();
    },

  },

}

</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterDiagram.vue